import api from "./api";

/** Uploads a File to the backend. Backend will route to S3 if configured,
 *  otherwise return a base64 data URL. Always returns the URL string. */
export async function uploadImage(file, folder = "uploads") {
  if (!file) throw new Error("No file");
  if (file.size > 10 * 1024 * 1024) throw new Error("File exceeds 10 MB limit");
  const fd = new FormData();
  fd.append("file", file);
  fd.append("folder", folder);
  const r = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data; // { url, storage, filename, size }
}
